module.exports = __webpack_public_path__ + "static/media/pin.c1cff57c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/pin.svg
// module id = 229
// module chunks = 0